class SwiperCartRecommend extends HTMLElement {
  constructor() {
    super();
    new Swiper('.mySwiper', {
      slidesPerView: 2,
      spaceBetween: 7,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}
customElements.define('swiper-cart', SwiperCartRecommend);
class SimilarProducts extends HTMLElement {
  constructor() {
    super();
    new Swiper('.similar-products', {
      slidesPerView: 2,
      spaceBetween: 7,
      breakpoints: {
        750: {
          slidesPerView: 4,
          spaceBetween: 7,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next-similar-products',
        prevEl: '.swiper-button-prev-similar-products',
      },
    });
  }
}
customElements.define('similar-products', SimilarProducts);
